// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type UpdateStatusResultFragment = { __typename?: 'UpdateStatusResultDTO', eInvoiceStatus: Types.EInvoiceStatusEnumDto | null, invoiceId: number };

export const UpdateStatusResultFragment = gql`
    fragment UpdateStatusResult on UpdateStatusResultDTO {
  eInvoiceStatus
  invoiceId
}
    `;
/* eslint-enable */